import React, { useEffect } from 'react';
import { VCOnboardingProvider } from '../../contexts/VCOnboardingContext';
import VCOnboardingContainer from '../../components/vc-onboarding/VCOnboardingContainer';
import styles from './VCOnboarding.module.css';

/**
 * Entry point for the VC onboarding flow. Wraps with provider and delegates to container.
 */
const VCOnboardingFlow: React.FC = () => {
  useEffect(() => {
    // Apply dark theme
    if (typeof document !== 'undefined') {
      document.documentElement.classList.add('onboarding-dark');
      document.body.classList.add('onboarding-dark');
      return () => {
        document.documentElement.classList.remove('onboarding-dark');
        document.body.classList.remove('onboarding-dark');
      };
    }
  }, []);

  return (
    <VCOnboardingProvider>
      <div className={styles.page}>
        {/* Glow dots background effect (matching signup page) */}
        <div className={styles.glowDots} aria-hidden="true">
          <div
            className={`${styles.dot} ${styles.dotBlue}`}
            style={{ top: "8%", left: "12%" }}
          />
          <div
            className={`${styles.dot} ${styles.dotPurple}`}
            style={{ top: "25%", right: "15%" }}
          />
          <div
            className={`${styles.dot} ${styles.dotYellow}`}
            style={{ bottom: "30%", left: "8%" }}
          />
          <div
            className={`${styles.dot} ${styles.dotRed}`}
            style={{ bottom: "15%", right: "20%" }}
          />
          <div
            className={`${styles.dot} ${styles.dotTeal}`}
            style={{ top: "50%", left: "3%" }}
          />
          <div
            className={`${styles.dot} ${styles.dotPink}`}
            style={{ top: "70%", right: "10%" }}
          />
        </div>

        <VCOnboardingContainer />
      </div>
    </VCOnboardingProvider>
  );
};

export default VCOnboardingFlow;

